// Redirect-after-login handler. Validates the ?redirect= against the allowlist
// and bounces. Same pattern dash uses to send users back to wiki/sms after login.

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { syncCookieFromSession } from '../lib/auth.js';
import { isValidRedirect } from '../lib/redirect.js';

export function PostLogin() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirect = params.get('redirect');

    (async () => {
      // Make sure the cookie is fresh before bouncing
      await syncCookieFromSession();

      if (redirect && isValidRedirect(redirect)) {
        window.location.href = redirect;
        return;
      }
      navigate('/admin', { replace: true });
    })();
  }, [location, navigate]);

  return <div className="p-12 text-brand-500">Redirecting…</div>;
}
